import * as types from './mutation-types'

const mutation = {
  [types.RESTRICTIONS_GET_ALL](state, res) {
    state.restrictions = res
  },
  [types.SET_SELECTED_RESTRICTION](state, newValue) {
    state.selected_restriction = newValue
  },
  [types.CREATE_RESTRICTION](state, newValue) {
    const { data } = newValue;

    if (data) {
      const id = data['id'].toString();
      Vue.set(state.restrictions, id, data);
    }

    state.restrictions.push( newValue )
  },
  [types.SAVE_RESTRICTION](state, restriction) {
    console.log(restriction)
    //create
    if (restriction.id === 0)
    {
      let newid = state.restrictions[state.restrictions.length -1].id ++
      restriction.id = newid;
      state.restrictions.push( restriction)
    }
    else {
      //update
      state.restrictions = [
        ...state.restrictions.filter(element => element.id !== restriction.id),
        restriction
      ]
    }
  },
  [types.DELETE_RESTRICTION](state, id) {
    let idx = state.restrictions.findIndex((x) => {
      return x.id === id
    })
    state.restrictions.splice(idx,1)
  }
}

export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/restrictions/mutations.js